export default "__VITE_ASSET__c0959605__"